import { xIcon } from '@progress/kendo-svg-icons';

import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { CarrierLoadBoardView } from 'TypeGen/carrier-load-board-view';

import { Button } from '@progress/kendo-react-buttons';

export default function MyCommandCell(
  decline: (quoteOffer: CarrierLoadBoardView) => void) {
  return class extends React.Component<GridCustomCellProps> {
    render() {
      const data = this.props.dataItem as CarrierLoadBoardView;
      return <td {...this.props.tdProps}><Button themeColor="warning" svgIcon={xIcon} title='Decline' aria-label='Decline' onClick={() => decline(data)} /></td>
    }
  }
}
